import React from 'react';
import styled from 'styled-components';

const RefundOptionsTitleH2 = styled.h2`
  border-bottom: 1px solid #ccc;
  padding: 10px 5px;
  font-size: 18px;
  font-weight: ${(props) => (props.bold ? 700 : 500)};
  margin: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: column;
  ${(props) => props.styles};
`;

const ReviewSectionHeader = ({ children, ...rest }) =>
  children ? (
    <RefundOptionsTitleH2 {...rest} data-testid="review-section-header">
      {children}
    </RefundOptionsTitleH2>
  ) : null;

export default ReviewSectionHeader;
